import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'components/Luxkit/Typography/Heading'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Faq from 'components/Common/Faq'
import TextButton from 'components/Luxkit/Button/TextButton'
import config from 'constants/config'
import Typography from 'components/Luxkit/Typography/Typography'

const Section = styled(Pane)`
  padding: ${rem(24)} 0;

  ${mediaQueryUp.tablet} {
    padding: ${rem(48)} 0;
  }
`

interface Props {
  slug: string;
}

function LoyaltyLandingPageFaqSection(props: Props) {
  const { slug } = props
  return <Section type="light-grey">
    <LayoutContainer variant="medium">
      <VerticalSpacer gap={24}>
        <Heading variant="heading3">
          Frequently asked questions
        </Heading>
        <Faq
          slug={slug}
          maxToShow={5}
        />
        <Typography align="center">
          <TextButton kind="secondary" to={config.contentLinks.societeFAQs.to}>
            Read more FAQs
          </TextButton>
        </Typography>
      </VerticalSpacer>
    </LayoutContainer>
  </Section>
}

export default LoyaltyLandingPageFaqSection
